export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Das Thema der Veranstaltung ist als solches relevant (unabhängig von dieser konkreten Veranstaltung).",
			},
			{
				id: 2,
				text: "Die Ziele der Veranstaltung waren für mich gut nachvollziehbar.",
			},
			{
				id: 3,
				text: "Der inhaltliche Aufbau der Veranstaltung war für mich gut nachvollziehbar.",
			},
			{
				id: 4,
				text: "Die Anforderungen der Veranstaltung waren angemessen.",
			},
			{
				id: 5,
				text: "Die Veranstaltung enthielt substantielle „hands-on“/praktische Anteile.",
			},
			{
				id: 6,
				text: "Die Einzel- und Gruppenaktivitäten waren sinnvoll.",
			},
			{
				id: 7,
				text: "Die Referent/innen waren engagiert und motiviert.",
			},
			{
				id: 8,
				text: "Die Referent/innen haben zum Mitdenken motiviert.",
			},
			{
				id: 9,
				text: "Die Referent/innen ermöglichten eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 10,
				text: "Die Referent/innen waren gut vorbereitet.",
			},
			{
				id: 11,
				text: "Die Referent/innen waren fachlich kompetent.",
			},
			{
				id: 12,
				text: "Die Referent/innen sind in angemessenem Umfang flexibel auf die Wünsche und Bedürfnisse der Teilnehmenden eingegangen.",
			},
			{
				id: 13,
				text: "Die Referent/innen haben in der Veranstaltung zur Interaktion angeregt.",
			},
			{
				id: 14,
				text: "Ich fand den Workshop didaktisch sinnvoll aufgebaut.",
			},
			{
				id: 15,
				text: "Ich habe das Gefühl, in der Veranstaltung Wichtiges gelernt zu haben.",
			},
			{
				id: 16,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 17,
				text: "Ich könnte jetzt das Gelernte bei Bedarf selbständig anwenden.",
			},
			{
				id: 18,
				text: "Ich habe vor, das Gelernte in Zukunft selbständig anzuwenden. ",
			},
			{
				id: 19,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 20,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 21,
				text: "Was fanden Sie besonders gut, was weniger gut?",
			},
			{
				id: 22,
				text: "Welche Inhalte der Veranstaltungen hätten mehr Raum verdient gehabt, welche weniger? Welche Inhalte hätten Sie sich zusätzlich gewünscht?",
			},
			{
				id: 23,
				text: "Welche Themen wünschen Sie sich für zukünftige GPP-Veranstaltungen?",
			},
			{
				id: 24,
				text: "In welcher Fachrichtung sind Sie tätig?",
				type: "medium",
			},
		],
	},
	{
		type: "age",
		id: 3,
		items: [
			{
				id: 25,
				text: "Alter: ",
			},
		],
	},
	{
		type: "special",
		id: 4,
		items: [
			{
				id: 26,
				text: "In welcher Phase Ihrer Promotion befinden Sie sich?",
				label: [
					{
						id: 1,
						text: "Anfangsphase",
					},
					{
						id: 2,
						text: "Mittelphase",
					},
					{
						id: 3,
						text: "Endphase",
					},
					{
						id: 4,
						text: "Postdoc",
					},
				],
			},
		],
	},
];
